module.exports = __webpack_public_path__ + "img/special_creamf_202402.05725128.jpg";